import { Form, InputNumber, Switch } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'QuotaForNewUser',
  'PreConsumedQuota',
  'QuotaForInviter',
  'QuotaForInvitee',
  'quota_setting.enable_free_model_pre_consume',
  'quota_setting.pre_consume_multiplier',
  'quota_setting.trust_quota_usd',
  'QuotaRemindEnabled',
]

export default function CreditSection({ options }: { options: OptionsAPI }) {
  const { getNumber, getBool, patch } = options

  return (
    <SettingSectionCard title="额度设置" subtitle="新用户、邀请与预消耗" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="新用户初始额度">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('QuotaForNewUser')}
              onChange={(v) => patch({ QuotaForNewUser: v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="预消耗额度">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('PreConsumedQuota')}
              onChange={(v) => patch({ PreConsumedQuota: v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="邀请人奖励额度">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('QuotaForInviter')}
              onChange={(v) => patch({ QuotaForInviter: v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="被邀请人奖励额度">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('QuotaForInvitee')}
              onChange={(v) => patch({ QuotaForInvitee: v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="免费模型预消耗">
            <Switch
              checked={getBool('quota_setting.enable_free_model_pre_consume', true)}
              onChange={(v) => patch({ 'quota_setting.enable_free_model_pre_consume': v })}
            />
          </Form.Item>
          <Form.Item
            label="预扣倍率"
            extra="预扣 = 预计输入费用 × 该倍率，只影响预扣，不影响最终结算（必须 > 0）"
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0.1}
              step={0.1}
              value={getNumber('quota_setting.pre_consume_multiplier', 1)}
              onChange={(v) => patch({ 'quota_setting.pre_consume_multiplier': v ?? 1 })}
            />
          </Form.Item>
          <Form.Item
            label="免预扣门槛（USD）"
            extra="余额高于该值时不做预扣，改用后结算；0 表示关闭"
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              step={1}
              value={getNumber('quota_setting.trust_quota_usd', 0)}
              onChange={(v) => patch({ 'quota_setting.trust_quota_usd': v ?? 0 })}
            />
          </Form.Item>
          <Form.Item label="额度不足提醒" extra="用户额度低于阈值时发送提醒">
            <Switch
              checked={getBool('QuotaRemindEnabled', true)}
              onChange={(v) => patch({ QuotaRemindEnabled: v })}
            />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
